<template>
  <div>
    <ob-collapse :type="10" :expand.sync="expandTools">
      <h4
        class="h4_design"
        style=" font-weight: 600; color:#475259;font-size:13.5px;"
        slot="collapse-title"
      >
        <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_tools-used.svg`" style="padding-right:8px;" />
        Tools Used
      </h4>
      <div slot="collapse-icon-custom" class="collapse-icon-custom">
        <span
          v-if="!openInput"
          @click.stop="openInput = true ; expandTools = true"
          style="margin-top: 5px;display: inline-block;cursor: pointer;"
        >
          <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_add.svg`" />
          <span style="color:#464444;font-weight: 700;margin-left: 5px;font-size: 12px;">Add Tools</span>
        </span>
      </div>
      <div slot="collapse-details">
        <template>
          <div>
            <template v-for="(item,index) in ToolsList">
              <div class="tools-view" v-if="item.Content != '' && item.Content != null">
                <span>{{item.Content}}</span>
                <span
                  style="margin-top: -25px; padding-top: 2px;padding-bottom: 6px;margin-left: 3px;"
                >
                  <span
                    class="cross-mark"
                    @click="confirmDeleteTool(item.Id , index)"
                    style="font-size: 11px; padding: 2px 5px;"
                  >&#10006;</span>
                </span>
              </div>
            </template>
            <div class="col-md-7 pL0 pR0 mL0 mR0" style="margin-top: 6px;margin-bottom: 12px;">
              <template v-if="openInput">
                <div class="col-md-7 pL0 pR0 mL0 mR0">
                  <ob-input v-model.trim="ToolUsed" placeholder="Enter Tool Name"></ob-input>
                </div>
                <div class="col-md-5 pL0 pR0 mL0 mR0" style="padding-left: 16px !important;">
                  <ob-button type="primary" :disabled="ToolUsed == ''" @click="addTool()">Add</ob-button>
                </div>
              </template>
            </div>
          </div>
        </template>
      </div>
    </ob-collapse>
  </div>
</template>

<script>
export default {
  props: ["content", "tools"],
  data() {
    return {
      expandTools: true,
      openInput: false,
      ToolUsed: "",
      ToolsList: [],
      selectedIndex: ""
    };
  },
  components: {},
  watch: {
    tools(val) {
      this.ToolsList = val;
    }
  },
  computed: {
    CreatedBy() {
      return this.loggedInUserObj.Name;
    }
  },
  created() {
    this.ToolsList = this.tools;
  },
  methods: {
    guid() {
      function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
          .toString(16)
          .substring(1);
      }
      return (
        s4() +
        s4() +
        "-" +
        s4() +
        "-" +
        s4() +
        "-" +
        s4() +
        "-" +
        s4() +
        s4() +
        s4()
      );
    },
    addTool() {
      var Toolsobj = {
        Title: this.ToolUsed,
        Type: 1
      };
      this.$parent.$parent.commanServiceForUpdate(Toolsobj);
      this.ToolUsed = "";
      this.openInput = false;
    },
    confirmDeleteTool(id, index) {
      this.selectedIndex = index;
      this.$alert2("Are you sure you want to delete ?", "Alert", {
        type: "confirm",
        yesButtonText: "Yes",
        noButtonText: "No",
        callback: action => {
          if (action === true) {
            var deleteObject = {
              Type: 1,
              TaskId: this.content.TaskId,
              ResourceId: id
            };
            this.$parent.$parent.deleteResource(deleteObject);
          }
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.tools-view {
  margin-top: 5px;
  color: #4a90e2;
  margin-left: 0px;
  border: 1px solid #4a90e2 !important;
  background: #e6eff9 !important;
  padding: 5px 10px;
  display: inline-block;
  border-radius: 30px;
  font-weight: bold;
  float: left;
  margin-right: 2%;
}
.cross-mark {
  padding: 0px 5px;
  border-radius: 100%;
  cursor: pointer;
}
.cross-mark:hover {
  // border: 1px solid #4A90E2 !important;
  background: #c2c2c2;
  padding: 0px 5px;
  border-radius: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/ESSProfile/Tasks/ToolsUsed.vue